import { defineMessage } from 'services/localization';

export const messages = {
    netAmountText: defineMessage('amount'),
    subtotal: defineMessage('subtotal'),
    discountAmountText: defineMessage('discount'),
    taxAmountText: defineMessage('tax_3'),
    shippingAmountText: defineMessage('shipping_1'),
    handlingAmountText: defineMessage('handling'),
    debitTotalText: defineMessage('debit_total'),
    creditTotalText: defineMessage('credit_total'),
    totalAmountText: defineMessage('total_1'),
};
